export default __webpack_public_path__ + "static/media/NMC_3.5a1bbeda.svg";